import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70f1b820"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_7 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-3"
}
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_9 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "acoes-item"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = {
  key: 0,
  class: "nested-table-container nested-indented"
}
const _hoisted_18 = {
  key: 0,
  class: "acoes-item"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_produto = _resolveComponent("selecionar-produto")!
  const _component_selecionar_unidade_produto_movimento = _resolveComponent("selecionar-unidade-produto-movimento")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_selecionar_engenharia_producao = _resolveComponent("selecionar-engenharia-producao")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_a_form_item, {
                  label: "Ordem",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      type: "number",
                      value: _ctx.state.ordem,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.ordem) = $event)),
                      style: {"text-align":"center"}
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_a_form_item, {
                  label: "Produto",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_selecionar_produto, {
                      codigoSelecionado: _ctx.state.codigoProduto,
                      "onUpdate:codigoSelecionado": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.codigoProduto) = $event)),
                      descricaoSelecionado: _ctx.state.descricaoSelecionado,
                      "onUpdate:descricaoSelecionado": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.descricaoSelecionado) = $event)),
                      empresas: _ctx.props.empresas,
                      modoDefinicaoProduto: true,
                      apresentarCodigoInterno: true,
                      tipoPCP: true,
                      onChange: _ctx.validarProdutoIntermediario
                    }, null, 8, ["codigoSelecionado", "descricaoSelecionado", "empresas", "onChange"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_a_form_item, {
                  label: "UN",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_selecionar_unidade_produto_movimento, {
                      codigoProdutoDefinicao: _ctx.state.codigoProduto,
                      "onUpdate:codigoProdutoDefinicao": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.codigoProduto) = $event)),
                      codigoUnidadeSelecionada: _ctx.state.codigoUnidade,
                      "onUpdate:codigoUnidadeSelecionada": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.codigoUnidade) = $event)),
                      empresas: _ctx.props.empresas,
                      sigla: _ctx.state.sigla,
                      "onUpdate:sigla": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.sigla) = $event)),
                      apresentarApenasSigla: true,
                      "casas-decimais": _ctx.state.casasDecimais,
                      "onUpdate:casasDecimais": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.casasDecimais) = $event))
                    }, null, 8, ["codigoProdutoDefinicao", "codigoUnidadeSelecionada", "empresas", "sigla", "casas-decimais"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_a_form_item, {
                  label: "Qtde da Fórmula",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_campo_numerico, {
                      valor: _ctx.state.quantidade,
                      "onUpdate:valor": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.quantidade) = $event)),
                      "quantidade-casas-decimais": _ctx.state.casasDecimais
                    }, null, 8, ["valor", "quantidade-casas-decimais"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_a_form_item, {
                  label: " ",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_checkbox, {
                      checked: _ctx.state.transferirLote,
                      "onUpdate:checked": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.transferirLote) = $event)),
                      disabled: _ctx.state.produtoIntemediario
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Transferir lote")
                      ]),
                      _: 1
                    }, 8, ["checked", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              (_ctx.state.habilitarPI)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_a_form_item, {
                      label: " ",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.state.produtoIntemediario,
                          "onUpdate:checked": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.produtoIntemediario) = $event)),
                          disabled: _ctx.state.transferirLote
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Detalhar P. I.")
                          ]),
                          _: 1
                        }, 8, ["checked", "disabled"])
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_a_form_item, {
                  label: " ",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      class: "ant-btn ant-btn-secondary",
                      style: {"width":"100%"},
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.adicionar(_ctx.state.indexSelecionado)))
                    }, _toDisplayString(_ctx.state.indexSelecionado === -1 ? 'Adicionar' : 'Editar'), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            (_ctx.state.produtoIntemediario)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_a_form_item, {
                      label: "Engenharia Produção",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_engenharia_producao, {
                          varios: false,
                          "codigo-selecionado": _ctx.state.codigoEngenhariaPI,
                          "onUpdate:codigoSelecionado": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.codigoEngenhariaPI) = $event)),
                          descricaoSelecionado: _ctx.state.nomeEngenhariaPI,
                          "onUpdate:descricaoSelecionado": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.nomeEngenhariaPI) = $event)),
                          "tipo-producao": 0,
                          "codigo-produto-definicao": _ctx.state.codigoProduto,
                          empresas: _ctx.props.empresas,
                          disabled: !_ctx.state.editavel
                        }, null, 8, ["codigo-selecionado", "descricaoSelecionado", "codigo-produto-definicao", "empresas", "disabled"])
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_card, {
          titulo: "ETAPAS",
          class: "ss-padding-separacao-esquerda"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_table, {
              columns: _ctx.gradeBase.colunas.filter(item => item.visible),
              "data-source": _ctx.computedMateriaPrima,
              rowKey: "codigo",
              pagination: false,
              size: "small",
              loading: _ctx.gradeBase.buscandoDados,
              "row-expandable": record => record.materiasPrimasPI && record.materiasPrimasPI.length > 0,
              expandedRowKeys: _ctx.expandedKeys,
              "onUpdate:expandedRowKeys": _cache[13] || (_cache[13] = keys => _ctx.expandedKeys = keys)
            }, {
              expandIcon: _withCtx(({ expanded, onExpand, record }) => [
                (record.materiasPrimasPI && record.materiasPrimasPI.length > 0)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      onClick: ($event: any) => (onExpand(record))
                    }, [
                      _createVNode(_component_icone, {
                        nome: expanded ? 'seta-para-baixo' : 'seta-para-direita'
                      }, null, 8, ["nome"])
                    ], 8, _hoisted_11))
                  : _createCommentVNode("", true)
              ]),
              bodyCell: _withCtx(({ column, index, text, record }) => [
                (column.customRenderRow === _ctx.ECustomRenderRow.IconeAcoes)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("a", {
                        onClick: ($event: any) => (_ctx.editar(index))
                      }, [
                        _createVNode(_component_icone, { nome: "editar" })
                      ], 8, _hoisted_13),
                      _createElementVNode("a", {
                        onClick: ($event: any) => (_ctx.excluir(index))
                      }, [
                        _createVNode(_component_icone, { nome: "excluir" })
                      ], 8, _hoisted_14)
                    ]))
                  : _createCommentVNode("", true),
                (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, 2)), 1))
                  : _createCommentVNode("", true),
                (column.key ==='quantidade')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, record.casasDecimais)), 1))
                  : _createCommentVNode("", true)
              ]),
              expandedRowRender: _withCtx(({ record }) => [
                (record.materiasPrimasPI.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("h4", null, "MPs do Produto Intermediário: " + _toDisplayString(record.descricao), 1),
                      _createVNode(_component_a_table, {
                        columns: _ctx.colunasMateriasPrimasPI.filter(item => item.visible),
                        "data-source": record.materiasPrimasPI,
                        rowKey: "codigo",
                        pagination: false,
                        size: "small"
                      }, {
                        bodyCell: _withCtx(({ column, text, index, record  }) => [
                          (column.customRenderRow === _ctx.ECustomRenderRow.IconeAcoes)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                _createElementVNode("a", {
                                  onClick: ($event: any) => (_ctx.editar(index))
                                }, [
                                  _createVNode(_component_icone, { nome: "editar" })
                                ], 8, _hoisted_19),
                                _createElementVNode("a", {
                                  onClick: ($event: any) => (_ctx.excluir(index))
                                }, [
                                  _createVNode(_component_icone, { nome: "excluir" })
                                ], 8, _hoisted_20)
                              ]))
                            : _createCommentVNode("", true),
                          (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, 2)), 1))
                            : _createCommentVNode("", true),
                          (column.key ==='quantidade')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, record.casasDecimais)), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["columns", "data-source"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["columns", "data-source", "loading", "row-expandable", "expandedRowKeys"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}